import './header.css';
import React from 'react';
import { VerticalSeparator } from '../components/separators';
import { Link } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, Dropdown } from 'react-bootstrap';
import { ReactComponent as HousesIcon } from '../icons/houses.svg'
import { ReactComponent as ContactsIcon } from '../icons/contacts.svg'
import { ReactComponent as TariffeIcon } from '../icons/rates1.svg'
import { ReactComponent as DintorniIcon } from '../icons/dintorni.svg'
import itaFlag from '../icons/bandiera_italiana.png'
import engFlag from '../icons/bandiera_inglese.png'

const Header = (props) => {

  const { selectedLanguage, handleLanguageChange } = props;

  return (
    <>
      <VerticalSeparator height={`62px`}></VerticalSeparator>
      <Navbar bg="light" expand="lg" fixed="top">
        <Navbar.Brand href="#" className='text-navbar-class'>Casa Santa Barbara</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" style={{ marginRight: '12px' }} />
        <Navbar.Collapse id="basic-navbar-nav" style={{ marginLeft: '12px', marginRight: '12px' }}>
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" style={{ fontSize: '20px' }}>Home</Nav.Link>
            <NavDropdown title={<><HousesIcon style={{ marginRight: '4px', marginTop: '-4px', width: '24px', height: '24px' }} />{selectedLanguage === 'ita' ? "Appartamenti" : "Apartments"}</>} id="basic-nav-dropdown">
              <NavDropdown.Item as={Link} to="/house1" >{selectedLanguage === 'ita' ? "Piano Terra" : "Ground Floor"}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/house2" >{selectedLanguage === 'ita' ? "Primo Piano" : "First Floor"}</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={Link} to="/rates">
              <TariffeIcon style={{ marginRight: '4px', width: '24px', height: '24px' }} />{selectedLanguage === 'ita' ? "Tariffe" : "Rates"}
            </Nav.Link>
            <Nav.Link as={Link} to="/surroundings">
              <DintorniIcon style={{ marginRight: '4px', width: '24px', height: '24px' }} />{selectedLanguage === 'ita' ? "Dintorni" : "Surroundings"}
            </Nav.Link>
            <Nav.Link as={Link} to="/contacts">
              <ContactsIcon style={{ marginRight: '4px', width: '24px', height: '24px' }} />{selectedLanguage === 'ita' ? "Contatti" : "Contacts"}
            </Nav.Link>
            <Dropdown align="end">
              <Dropdown.Toggle variant="light" id="language-dropdown">
                {selectedLanguage === 'ita' ? (
                  <img src={itaFlag} alt="ITA Flag" style={{ marginRight: '4px', marginTop: '-2px', width: '28px', height: '28px' }} />
                ) : (
                  <img src={engFlag} alt="ENG Flag" style={{ marginRight: '4px', marginTop: '-2px', width: '28px', height: '28px' }} />
                )}
                {selectedLanguage.toUpperCase()}
              </Dropdown.Toggle>
              <Dropdown.Menu >
                <Dropdown.Item onClick={() => handleLanguageChange('ita')} active={selectedLanguage === 'ita'}>
                  <img src={itaFlag} alt="ITA Flag" style={{ marginRight: '4px', marginTop: '-2px', width: '24px', height: '24px' }} />ITA
                </Dropdown.Item>
                <Dropdown.Item onClick={() => handleLanguageChange('eng')} active={selectedLanguage === 'eng'}>
                  <img src={engFlag} alt="ENG Flag" style={{ marginRight: '4px', marginTop: '-2px', width: '24px', height: '24px' }} />ENG
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>

  );
}

export default Header;